import React from 'react';

import Badge from '../common/Badge';

// Mirrors RoleBadge - one place mapping the backend's derived `status`
// (active/inactive/deleted - see models/user.py's UserStatus) to a
// label/variant, reused by the users table and the user detail page.
const STATUS_CONFIG = {
  active: { label: 'Active', variant: 'listening' },
  inactive: { label: 'Inactive', variant: 'paused' },
  deleted: { label: 'Deleted', variant: 'disconnected' },
};

function StatusBadge({ status }) {
  const config = STATUS_CONFIG[status] || { label: status, variant: 'neutral' };

  return <Badge variant={config.variant}>{config.label}</Badge>;
}

export default StatusBadge;
